import { authClient, API } from "../../utils/index";

export const getTemplateCategories = (params = {}) => {
	const search = new URLSearchParams();
	if (params.all) search.set("all", "1");
	const qs = search.toString();
	return authClient().get(`${API}/template-category${qs ? `?${qs}` : ""}`);
};

export const createTemplateCategory = (data) => {
	return authClient().post(`${API}/template-category`, data);
};

export const updateTemplateCategory = (id, data) => {
	return authClient().put(`${API}/template-category/${encodeURIComponent(String(id || ""))}`, data);
};

export const deleteTemplateCategory = (id) => {
	return authClient().delete(`${API}/template-category/${encodeURIComponent(String(id || ""))}`);
};
